import { defaultBruteforceSettings, normalizeBruteforceSettings } from "../bruteforce/defaults.js";

const KEY = "red_ball_port_save";

export class SaveStore {
  constructor(storage = window.localStorage) {
    this.storage = storage;
    this.state = this.read();
  }

  read() {
    try {
      const raw = this.storage.getItem(KEY);
      if (!raw) {
        return {
          levelsAvaiable: 1,
          botInputScript: "",
          bruteforceSettings: defaultBruteforceSettings(),
          bruteforceSessions: [],
          cameraZoom: 1,
          hitboxStrokeWidth: 2,
          showFinishHitbox: false,
          showBallHitbox: false,
          autoAdvanceLevel: true,
          spikesKill: false,
          fixedLevelTransitionTiming: false,
          tasDeathWarp: false,
        };
      }
      const data = JSON.parse(raw);
      return {
        levelsAvaiable: Math.max(1, Number(data.levelsAvaiable || 1)),
        botInputScript: typeof data.botInputScript === "string" ? data.botInputScript : "",
        bruteforceSettings: normalizeBruteforceSettings(data.bruteforceSettings),
        bruteforceSessions: Array.isArray(data.bruteforceSessions)
          ? data.bruteforceSessions.map((session) => normalizeBruteforceSettings(session))
          : [],
        cameraZoom: Math.min(4, Math.max(0.1, Number(data.cameraZoom) || 1)),
        hitboxStrokeWidth: Math.min(2, Math.max(0.1, Number(data.hitboxStrokeWidth) || 2)),
        showFinishHitbox: Boolean(data.showFinishHitbox),
        showBallHitbox: Boolean(data.showBallHitbox),
        autoAdvanceLevel: data.autoAdvanceLevel !== false,
        spikesKill: data.spikesKill === true,
        fixedLevelTransitionTiming: data.fixedLevelTransitionTiming === true,
        tasDeathWarp: data.tasDeathWarp === true,
      };
    } catch {
        return {
          levelsAvaiable: 1,
          botInputScript: "",
          bruteforceSettings: defaultBruteforceSettings(),
          bruteforceSessions: [],
          cameraZoom: 1,
          hitboxStrokeWidth: 2,
          showFinishHitbox: false,
          showBallHitbox: false,
          autoAdvanceLevel: true,
          spikesKill: false,
          fixedLevelTransitionTiming: false,
          tasDeathWarp: false,
        };
    }
  }

  write() {
    this.storage.setItem(KEY, JSON.stringify(this.state));
  }

  unlock(level) {
    if (level > this.state.levelsAvaiable) {
      this.state.levelsAvaiable = level;
      this.write();
    }
  }
}
